import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { CheckCircle, XCircle, Loader } from 'lucide-react';

const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL || 'http://localhost:5000/api'}/auth/verify-email/${token}`
        );

        const data = await response.json();

        if (response.ok) {
          setStatus('success');
          setMessage(data.message || 'Email verified successfully!');
          // Redirect to login after 3 seconds
          setTimeout(() => {
            navigate('/login');
          }, 3000);
        } else {
          setStatus('error');
          setMessage(data.error || 'Verification failed. The link may be invalid or expired.');
        }
      } catch (error) {
        setStatus('error');
        setMessage('Something went wrong. Please try again.');
      }
    };

    if (token) {
      verifyEmail();
    }
  }, [token, navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      background: 'var(--background)',
    }}>
      <div style={{
        maxWidth: '500px',
        width: '100%',
        padding: '40px',
        background: 'var(--cardBackground)',
        borderRadius: '16px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        textAlign: 'center',
      }}>
        {status === 'verifying' && (
          <>
            <Loader size={64} color="var(--primary)" style={{ animation: 'spin 1s linear infinite', margin: '0 auto 20px' }} />
            <h1 style={{ marginBottom: '10px' }}>Verifying Email...</h1>
            <p style={{ color: 'var(--textSecondary)' }}>
              Please wait while we verify your email address.
            </p>
          </>
        )}

        {status === 'success' && (
          <>
            <CheckCircle size={64} color="var(--success)" style={{ margin: '0 auto 20px' }} />
            <h1 style={{ marginBottom: '10px', color: 'var(--success)' }}>Email Verified!</h1>
            <p style={{ color: 'var(--textSecondary)', marginBottom: '20px' }}>
              {message}
            </p>
            <p style={{ fontSize: '14px', color: 'var(--textSecondary)' }}>
              Redirecting to login page...
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <XCircle size={64} color="var(--error)" style={{ margin: '0 auto 20px' }} />
            <h1 style={{ marginBottom: '10px', color: 'var(--error)' }}>Verification Failed</h1>
            <p style={{ color: 'var(--textSecondary)', marginBottom: '30px' }}>
              {message}
            </p>
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
              <Link
                to="/login"
                style={{
                  padding: '12px 24px',
                  background: 'var(--primary)',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '8px',
                  fontWeight: '600',
                }}
              >
                Go to Login
              </Link>
              <Link
                to="/resend-verification"
                style={{
                  padding: '12px 24px',
                  background: 'var(--secondary)',
                  color: 'var(--text)',
                  textDecoration: 'none',
                  borderRadius: '8px',
                  fontWeight: '600',
                }}
              >
                Resend Email
              </Link>
            </div>
          </>
        )}
      </div>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default VerifyEmail;
